<template>
  <div class="mine_page">
    <van-nav-bar :title="$t('q60')" class="header_b"></van-nav-bar>
    <div class="u_bg"></div>
    <div class="content_re">
    <div class="info_card_u">
      <div class="left_c">
        <div class="user_img_b" v-if="userInfo.header_img">
          <img :src="userInfo.header_img" alt="" class="user_set"/>
        </div>
        <div class="user_img_b" v-if="!userInfo.header_img">
          <img src="/img/neww/userpic.png" alt="" class="user_set"/>
        </div>
        
        <div class="tc">
          <div class="">{{userInfo.username}}</div>
          <div class="c_c">{{userInfo.vip}}</div>
        </div>
      </div>
      <img src="/img/neww/download (1).png" @click="$router.push({path:'/IndexInfo'});" class="c_set"/>
    </div>
    <div class="c_card_b">
      <div class="hang_c">
        <div class="q1">{{ $t("q5") }}</div>
        <div class="q2">{{userInfo.money}}</div>
      </div>
      <div class="hang_c">
        <div class="q1">{{ $t("q6") }}</div>
        <div class="q2">{{userInfo.xinyu}}</div>
      </div>
    </div>
    <div class="c_vip" v-html="sanitizeHtml(contactUsData.content)">
    <div style="display: flex; gap: 30px; align-items: center;"> <!-- 邮箱部分 --> <div style="flex: 1; display: flex; align-items: center; background: rgba(0,0,0,0.08); border-radius: 8px; padding: 15px 20px;"> <div style="flex: 1;"> <div style="font-size: 15px; color: #000; font-weight: 500; margin-bottom: 3px;">邮箱</div> <a href="mailto:susanmiller6584@gmail.com" style="font-size: 13px; color: rgba(0,0,0,0.6); text-decoration: none;">susanmiller6584@gmail.com</a> </div> <div style="flex-shrink: 0; margin-left: 12px;"> <a href="mailto:your-email@example.com" style="display: block;"> <img src="https://sparkme.cc/img/neww/ico_new.png" alt="邮箱" style="width: 40px; height: 40px; object-fit: contain;"/> </a> </div> </div> <!-- 飞机部分 --> <div style="flex: 1; display: flex; align-items: center; background: rgba(0,0,0,0.08); border-radius: 8px; padding: 15px 20px;"> <div style="flex: 1;"> <div style="font-size: 15px; color: #000; font-weight: 500; margin-bottom: 3px;">在线客服</div> <a href="" target="_blank" style="font-size: 13px; color: rgba(0,0,0,0.6); text-decoration: none;">点击联系客服</a> </div> <div style="flex-shrink: 0; margin-left: 12px;"> <a href="https://t.me/kleinerperkins888" target="_blank" style="display: block;"> <img src="https://sparkme.cc/img/neww/ico_new.png" alt="客服" style="width: 40px; height: 40px; object-fit: contain;"/> </a> </div> </div></div>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/Withdraw'});">
      <div class="left_y" >
        <img src="/img/neww/ico_txzx.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q9") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/GameRecord'});">
      <div class="left_y">
        <img src="/img/neww/ico_bb.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q10") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/VoteRecord'});">
      <div class="left_y">
        <img src="/img/neww/ico_vote.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("my.vote_record") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/RechargeList'});">
      <div class="left_y">
        <img src="/img/neww/ico_czjl.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q11") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <!-- @click="toNotice()" -->
    <div class="hang_bttn"  @click="$router.push({path:'/WithdrawRecord'});"> 
      <div class="left_y">
        <img src="/img/neww/ico_tkjl.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q12") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/BindCard'});">
      <div class="left_y">
        <img src="/img/neww/icon_user_card.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q13") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>

  </div>
  </div>



</template>

<script>
export default {
  data() {
    return {
      userInfo: {
      },
      menu_top: 40,
      isLoading: false,
      showContactUsPopup: false,
      contactUsData: {
        title: '',
        content: ''
      },
      contactUsTitle: '',
      contactUsSubtitle: ''
    };
  },
  methods: {
    sanitizeHtml(html) {
      if (!html) return '';
      
      const allowedTags = ['p', 'strong', 'b', 'i', 'em', 'u', 'br', 'div', 'span', 'ul', 'ol', 'li', 'a','img'];
      const dangerousEvents = ['onload', 'onerror', 'onclick', 'onmouseover', 'onmouseout', 'onfocus', 'onblur', 'onkeydown', 'onkeyup', 'onkeypress'];
      const dangerousProtocols = ['javascript:', 'vbscript:', 'data:', 'file:', 'ftp:'];
      
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      const elements = tempDiv.querySelectorAll('*');
      elements.forEach(el => {
        const tagName = el.tagName.toLowerCase();
        
        if (!allowedTags.includes(tagName)) {
          el.remove();
          return;
        }
        
        const attrs = el.attributes;
        for (let i = attrs.length - 1; i >= 0; i--) {
          const attr = attrs[i];
          const attrName = attr.name.toLowerCase();
          const attrValue = attr.value.toLowerCase();
          
          const isDangerousEvent = dangerousEvents.some(event => attrName.startsWith(event));
          const isDangerousProtocol = dangerousProtocols.some(protocol => attrValue.includes(protocol));
          
          if (isDangerousEvent || isDangerousProtocol || (attrName !== 'class' && attrName !== 'style' && attrName !== 'href'&&attrName !== 'src')) {
            el.removeAttribute(attr.name);
          }else{
            if(attrName === 'href'){
              el.setAttribute('target', '_blank');
            }
          }
        }
        
        if (el.style) {
          const styleValue = el.style.cssText.toLowerCase();
          if (styleValue.includes('expression(') || styleValue.includes('javascript:') || styleValue.includes('behavior:')) {
            el.removeAttribute('style');
          }
        }
      });
      
      return tempDiv.innerHTML;
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: {
          'balance': this.userInfo.money
        }
      })
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      })
    },
    toService() {
      console.log(this.$store.getters.getBaseInfo)
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("Withdraw");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo,"this.userInfo---174");
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    showContactUs() {
      this.$http({
        method: 'get',
        url: 'contact_us'
      }).then(res => {
        if (res.code === 200) {
          this.contactUsData = res.data;
          // this.contactUsTitle = res.data.title || this.$t("q7");
          // this.contactUsSubtitle = this.$t("q8");
          // this.showContactUsPopup = true;
        } else {
          this.$toast(res.msg);
        }
      })
    },

  },
  created() {
    this.showContactUs();
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped lang="less">
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.mine_page {
  position: relative;
  background-color: #101012;
  top:100px;
  height: 100vh;
  box-sizing: border-box;
  .content_re{
    position: absolute;
    width: 100%;
    padding-bottom: 100px;

  }
  .header_b{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  .u_bg {
 
    background: linear-gradient(to right, #efcba7, #dcab76);
    height: 300px;
    position: absolute;
    width: 100%;
    // z-index: -1;
  }
  .hang_bttn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px;
    border-bottom: 1px solid #333;
    .left_y{
      display: inline-flex;
      align-items: center;
      color: #e6b98a;
      .cl_set{
        height: 60px;
        margin-right: 20px;
      }
    }
    .right_h{
      height: 34px;
    }
  }
  .c_card_b{
    display: flex;
    align-items: center;
    background: linear-gradient(120deg,#212121,#313131);
    border-radius: 10px;
    margin: 0 40px;
    padding: 46px 0;
    .hang_c{
      flex:1;
      text-align: center;
      .q1{
        color: #fff;
      }
      .q2{
        color: #e6b98a;
        padding-top: 24px;
      }
    }
  }
  .c_vip{
    margin: 20px;
    background: linear-gradient(to right, #efcba7, #dcab76);
    // background: url('/img/neww/header-bg.png') no-repeat center center;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 10px;
    color: black;
    .left{
        
    .ee{
      font-size: 24px;
    }
    .down{
      font-size: 28px;
    }
    }
    .right{
      //

      text-align: right;
      font-size: 28px;
    }
  }
  .info_card_u{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 60px 20px 40px;
    .left_c{
      display: inline-flex;
      align-items: center;
      .user_set{
        width: 120px;
        border: 2px solid #fff;
        border-radius: 50%;
      }
      .tc{
        margin-left: 30px;
        .c_c{
          padding-top: 16px;
        }
      }
    }
    .c_set{
      width: 40px;
    }
  }
  .c_card_b{
    background-color: #fff;
  }
}



.mine {
  position: relative;
  bottom: 20px;

  /* background: url('/img/usertop.660cec17.png') no-repeat top -16vw center; */
  .page-bg {
    background: linear-gradient(to right, #efcba7, #dcab76);
  }
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
  background: content-box;
}

.mine .header {

  padding-bottom: 100px;
  background-size: contain
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  line-height: 0px;
  color: #fff;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
}

.mine .page-bg {
  height: 500px;

}

.mine .content {
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
  font-size: 50px;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 33.3%;
  height: 180px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 24px;
  color: #432788;
  font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  background-color: #a06098;
  border-radius: 15px;

  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #fff;
  font-size: 32px;
}

.font-gray {
  color: #fff;
  font-size: 28px;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 10px;
}

.mine .wrapper .content .wallet .part-3 {
  display: flex;
  align-items: center;
  height: 80px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #fff;
  font-weight: 700;
}

/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}

.btn {
  margin: 40px 0;
}

.contact-us-popup {
  padding: 20px;
  
  .contact-title {
    font-size: 24px;
    font-weight: bold;
    color: #f3c7a2;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .contact-content {
    font-size: 16px;
    color: #ffffff;
    line-height: 1.6;
    
    p {
      margin-bottom: 12px;
    }
    
    strong {
      color: #e6b98a;
    }
  }
}
</style>
<style lang="less" scoped>
.van-nav-bar {
  background-color: #1c1c1c;
}

.mine.page {
  padding-top: 50px;
}
</style>
